import React from 'react';
import {classes, style} from './doppe-action-unavailable-preview.st.css';
import {evaluateFunction, Values} from "@wix/devzai-utils-common";
import {
    DoppeActionTypeWidgetContentLayoutContentAlignment,
    DoppeActionTypeWidgetContentLayoutNew
} from '../doppe-action-type-widget-content-layout-new/doppe-action-type-widget-content-layout-new';
import {
    DoppeActionTypeWidgetInnerTitle
} from "../doppe-action-type-widget-inner-title/doppe-action-type-widget-inner-title";
import {Icon} from "@wix/devzai-utils-react";
import {
    DoppeViewerAppIconActionErrorContentLoadingFailed,
    DoppeViewerAppIconActionErrorMissingEntity
} from "../doppe-viewer-icons/doppe-viewer-icons";
import {
    DoppeActionTypeWidgetInnerDescription
} from "../doppe-action-type-widget-inner-description/doppe-action-type-widget-inner-description";
import {useDoppeViewerLangDictionary} from "../doppe-viewer-lang-dictionary/doppe-viewer-lang-dictionary";

export const DoppeActionUnavailableReason = {
    ContentUnavailable: 'contentUnavailable',
    ContentLoadingError: 'contentLoadingError'
} as const;

export type DoppeActionUnavailableReason = Values<typeof DoppeActionUnavailableReason>;

const showUnavailableIcon = false;

export const DoppeActionUnavailablePreview = React.memo(function DoppeActionUnavailablePreview(props: DoppeActionUnavailablePreview.Props) {
    const {
        title,
        className,
        reason,
        ...htmlAttributes
    } = props;

    const doppeViewerLang = useDoppeViewerLangDictionary();

    const widgetContent = evaluateFunction(() => {
        switch (reason) {
            case DoppeActionUnavailableReason.ContentUnavailable: {
                return {
                    title: title ?? doppeViewerLang.contentUnavailableTitleDefault,
                    description: undefined,
                    icon: showUnavailableIcon ? DoppeViewerAppIconActionErrorMissingEntity : undefined
                }
            }
            case DoppeActionUnavailableReason.ContentLoadingError: {
                return {
                    title: doppeViewerLang.contentLoadingErrorTitle,
                    description: doppeViewerLang.contentLoadingErrorDescription,
                    icon: DoppeViewerAppIconActionErrorContentLoadingFailed
                }
            }
        }
    })

    return (
        <DoppeActionTypeWidgetContentLayoutNew
            {...htmlAttributes}
            className={style(classes.root, className)}
            contentAlignment={DoppeActionTypeWidgetContentLayoutContentAlignment.Center}
            mainMedia={widgetContent.icon ? (
                <div>
                    <Icon
                        className={style(classes.errorIcon, {})}
                        icon={widgetContent.icon}
                    />
                </div>
            ) : undefined}
        >
            <DoppeActionTypeWidgetInnerTitle>
                {widgetContent.title}
            </DoppeActionTypeWidgetInnerTitle>
            {widgetContent.description ? (
                <DoppeActionTypeWidgetInnerDescription>
                    {widgetContent.description}
                </DoppeActionTypeWidgetInnerDescription>
            ) : null}
        </DoppeActionTypeWidgetContentLayoutNew>
    );
});

export namespace DoppeActionUnavailablePreview {

    export interface Props extends React.HTMLAttributes<any> {
        title?: string;
        reason: DoppeActionUnavailableReason
    }
}
